<template>
  <v-app>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <Header />
          <v-card class="mx-4 py-1 mt-9 mb-n5 theme" style="z-index: 1">
            <v-card-title primary-title>
              <v-spacer />
              <div class="white--text display-1 font-weight-light">Login</div>
              <v-spacer />
            </v-card-title>
          </v-card>
          <v-card class="elevation-0">
            <v-card-text>
              <div class="my-3">
                <v-btn
                  plain
                  small
                  class="caption theme-text text-capitalize"
                  @click="register"
                  >Register
                </v-btn>
                <v-btn
                  plain
                  small
                  class="caption theme-text text-capitalize"
                  @click="redirectToForgetPassword"
                  style="float: right"
                  >Forgot Password?
                </v-btn>
                <div style="clear: both"></div>
              </div>
              <v-alert :value="alertShow" :type="alertType">{{
                alertText
              }}</v-alert>
              <v-form ref="form" v-model="valid">
                <v-text-field
                  v-model="email"
                  label="Login"
                  type="text"
                  hint="Your registered email"
                  persistent-hint
                  tabindex="1"
                  autocomplete="email"
                  :autofocus="true"
                  :rules="[validationRules.email, validationRules.required]"
                  class="mb-4"
                />
                <v-text-field
                  v-model="password"
                  label="Password"
                  type="password"
                  hint="You password"
                  autocomplete="current-password"
                  tabindex="2"
                  persistent-hint
                  :rules="[validationRules.password, validationRules.required]"
                />
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                class="mr-2 action rounded-sm white--text"
                depressed
                tabindex="3"
                @click="login"
                >Login
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import Header from "@/components/Header";
import { Actions } from "@/views/actions";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";

export default {
  name: Component.Auth.Login,
  data: () => ({
    email: "",
    valid: true,
    password: "",
    alertShow: false,
    alertType: "warning",
    alertText: "",
  }),
  components: { Header },
  methods: {
    register() {
      this.$router.push({ name: Component.Auth.Register });
    },

    login() {
      if (this.$refs.form.validate()) {
        const data = { email: this.email, password: this.password };

        this.$store
          .dispatch(Actions.LoginUser, data)
          .then(() => {
            this.$router.push({ name: Component.Protected.Dashboard });
          })
          .catch((e) => this.handleError(e));
      }
    },

    handleError(e) {
      this.alertShow = true;
      this.alertType = "warning";
      switch (e.code) {
        case "auth/user-not-found":
          this.alertText = Constants.Login.Error.UserNotFound;
          break;
        case "auth/wrong-password":
          this.alertText = Constants.Login.Error.WrongPassword;
          break;
        case "auth/user-disabled":
          this.alertText = Constants.Login.Error.InactiveAccount;
          break;
        default:
          this.alertText = e.message;
      }
    },

    redirectToForgetPassword() {
      this.$router.push({ name: Component.Auth.ResetPassword });
    },

    reset() {
      this.alertShow = false;
      this.alertType = "warning";
      this.alertText = "";
      this.$refs.form.reset();
    },
  },
};
</script>

<style scoped>
div.container {
  /*background  : radial-gradient(#c4a0eb, #542aff) no-repeat;*/
  place-items: center center;
  background: radial-gradient(#9c1a5f, #551738) no-repeat;
}

div.v-alert.warning {
  border-radius: 3px;
}

.v-input {
  font-weight: 400;
}

div.input {
  color: #ff0000 !important;
}
</style>